import {
    isExtensionKey,
    isQueueKey,
    isReferKey,
    isChannelKey,
} from 'flow/utils';
import {
    createQueueCalendarEvent,
    updateQueueCalendarEvent,
    removeQueueCalendarEvent,
} from 'flow/actions/pbx-actions';
import {
    createReferCalendarEvent,
    updateReferCalendarEvent,
    removeReferCalendarEvent,
} from 'flow/actions/pbx-actions';
import {
    createChannelCalendarEvent,
    updateChannelCalendarEvent,
    removeChannelCalendarEvent,
} from 'flow/actions/channels-actions';
import {
    createCalendarEvent,
    updateCalendarEvent,
    removeCalendarEvent,
} from 'flow/actions/extension-actions';

export const createEvent = (calendarEvent, entityKey) => (dispatch) => {
    if (isQueueKey(entityKey)) {
        dispatch(createQueueCalendarEvent(entityKey, calendarEvent));
    } else if (isReferKey(entityKey)) {
        dispatch(createReferCalendarEvent(entityKey, calendarEvent));
    } else if (isChannelKey(entityKey)) {
        dispatch(createChannelCalendarEvent(entityKey, calendarEvent));
    } else if (isExtensionKey(entityKey)) {
        dispatch(createCalendarEvent(entityKey, calendarEvent));
    } else {
        console.warn('Unsupported entity: ' + entityKey);
    }
};

export const removeEvent = (calendarEvent, entityKey) => (dispatch) => {
    if (isQueueKey(entityKey)) {
        dispatch(removeQueueCalendarEvent(entityKey, calendarEvent.get('key')));
    } else if (isReferKey(entityKey)) {
        dispatch(removeReferCalendarEvent(entityKey, calendarEvent.get('key')));
    } else if (isChannelKey(entityKey)) {
        dispatch(
            removeChannelCalendarEvent(entityKey, calendarEvent.get('key')),
        );
    } else if (isExtensionKey(entityKey)) {
        dispatch(removeCalendarEvent(entityKey, calendarEvent.get('key')));
    } else {
        console.warn('Unsupported entity: ' + entityKey);
    }
};

export const updateEvent = (calendarEvent, entityKey) => (dispatch) => {
    if (isQueueKey(entityKey)) {
        dispatch(
            updateQueueCalendarEvent(
                entityKey,
                calendarEvent.get('key'),
                calendarEvent,
            ),
        );
    } else if (isReferKey(entityKey)) {
        dispatch(
            updateReferCalendarEvent(
                entityKey,
                calendarEvent.get('key'),
                calendarEvent,
            ),
        );
    } else if (isChannelKey(entityKey)) {
        dispatch(
            updateChannelCalendarEvent(
                entityKey,
                calendarEvent.get('key'),
                calendarEvent,
            ),
        );
    } else if (isExtensionKey(entityKey)) {
        dispatch(
            updateCalendarEvent(
                entityKey,
                calendarEvent.get('key'),
                calendarEvent,
            ),
        );
    } else {
        console.warn('Unsupported entity: ' + entityKey);
    }
};
